<template>
  <el-drawer
  :title="$t('products.filters.title')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form label-position="top">
      <el-form-item>
        <el-button @click="handleResetFilters()" size="mini">{{$t('products.filters.reset')}}</el-button>
      </el-form-item>
      <el-collapse v-model="activeName" >
        <el-collapse-item :title="$t('products.filters.availableTitle')" name="1">
          <el-form-item>
            <el-checkbox-group v-model="productsAvailabilityInd" size="small">
              <el-checkbox-button label="1">{{$t('products.filters.inStock')}}</el-checkbox-button>
              <el-checkbox-button label="0">{{ $t('products.filters.inSupply') }}</el-checkbox-button>
              <el-checkbox-button label="2">{{$t('products.filters.availabiltyAll')}}</el-checkbox-button>
            </el-checkbox-group>
        </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('products.filters.web')" name="2">
          <el-form-item>
            <el-radio-group v-model="productPublished">
              <el-radio-button label="1">{{$t('products.filters.published')}}</el-radio-button>
              <el-radio-button label="0">{{$t('products.filters.notPublished')}}</el-radio-button>
              <el-radio-button label="2">{{$t('products.filters.webAll')}}</el-radio-button>
            </el-radio-group>
        </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('products.filters.tags')" name="3">
          <el-form-item>
            <el-input v-model="tagSearch"></el-input>
           </el-form-item>
          <el-form-item>
             <el-checkbox-group  v-model="checkedTags" >
               <el-row :gutter="20" v-for="tag in filteredListTags" :key="tag.id">
                 <el-col>
                   <el-checkbox :label="tag.id" style="margin-left:0px;">{{tag.code}}</el-checkbox>
                 </el-col>
               </el-row>
             </el-checkbox-group>
           </el-form-item>
        </el-collapse-item>
      </el-collapse>
   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'inventory-product-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      activeName : ['1'],
      tagSearch: '',
    };
  },components: {

  },
  watch : {

  },
	methods: {
    handleResetFilters(){
      if (this.usingStore && this.store === 'inventoryProducts') {
        this.resetFilters();
      } else if (this.usingStore && this.store === 'products') {
        this.resetProductFilters();
      }
    },
    emitFiltersChange() {
      this.$emit('filtersChange', {
        activeFilters: this.activeFilters,
        filters: {
          tags: this.filters.checkedTags,
          productsAvailabilityInd: this.productsAvailabilityInd,
          productPublished: this.productPublished,
          cmsProductPublished: this.cmsProductPublished,
        }
      }) ;
    },
    open(){
      this.fetchTags();
    },
    handleClose(){
      this.$emit('close');
    },
    removeAccent(str){
      return str
         .replace(/[áàãâä]/gi,"a")
         .replace(/[éè¨ê]/gi,"e")
         .replace(/[íìïî]/gi,"i")
         .replace(/[óòöôõ]/gi,"o")
         .replace(/[úùüû]/gi, "u")
         .replace(/[ç]/gi, "c")
         .replace(/[ñ]/gi, "n")
         .replace(/[^a-zA-Z0-9]/g,"");
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('inventoryProducts', ['invalidateProductList', 'fetchSearchedProducts','resetFilters','setCheckedProductsTags','setProductWithQuantity','setProductInSupply', 'setProductPublishedInd', 'setProductAvailabilityInd']),
    ...mapActions('products',['fetchTags', 'setCMSProductPublishedInd', 'resetProductFilters']),
	},
  watch: {
    // whenever question changes, this function will run
    checkedTags() {
        this.emitFiltersChange();
    },
    productsAvailabilityInd () {
      this.emitFiltersChange();
    },
    productPublished () {
      this.emitFiltersChange();
    },
    cmsProductPublished () {
      this.emitFiltersChange();
    },

  },
	computed: {
    activeFilters () {
      let nbActive = 0;
      if (this.showCmsProductFilters === false) {
        if(this.productsAvailabilityInd != null) nbActive++;
        if(this.productPublished != 2) nbActive++;
      } else {
        if(this.cmsProductPublished != 2) nbActive++;
      }

      if(this.filters.checkedTags.length>0) nbActive += this.filters.checkedTags.length;
      return nbActive;
    },
		checkedTags : {
			set(val){
        this.setCheckedProductsTags(val);
        // // this.emitFiltersChange();
        // if (this.usingStore && this.store === 'inventoryProducts') {
        //   this.invalidateProductList();
        //   this.fetchSearchedProducts();
        // }

      },
			get(){return this.filters.checkedTags}
		},
    productsAvailabilityInd : {
      set(availability){
        this.setProductAvailabilityInd(availability);
        // // this.emitFiltersChange();
        // if (this.usingStore && this.store === 'inventoryProducts') {
        //   this.invalidateProductList();
        //   this.fetchSearchedProducts();
        // }
      },
			get(){return this.getFilterProductAvailabilityInd }
    },
    productPublished : {
      set(published){
        this.setProductPublishedInd(published);
        // // this.emitFiltersChange();
        // if (this.usingStore && this.store === 'inventoryProducts') {
        //   this.invalidateProductList();
        //   this.fetchSearchedProducts();
        // }
      },
			get(){return this.getFilterPublishedInd }
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    filteredListTags (){
      if (this.tagSearch === '') return this.listTags;
      return this.listTags.filter(tag => this.removeAccent(tag.code).toLowerCase().indexOf(this.removeAccent(this.tagSearch).toLowerCase()) !== -1)
    },
    ...mapState('products',['listTags']),
    ...mapState('inventoryProducts',['filters']),
    ...mapGetters('inventoryProducts', ['getFilterPublishedInd', 'getFilterProductAvailabilityInd']),
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
